/**
 * @author Sirisha.M
 */
import React, { useState, useEffect } from 'react';
import { Tree, message } from 'antd';
import { DownOutlined } from '@ant-design/icons';
const { TreeNode } = Tree;
const HierarchyModal = (props) => {
  const [treeData, setTreeData] = useState(props.treeData || []);
  const [checkedArray, setCheckedArray] = useState(props.checkedArray || null);


  useEffect(() => {
    if (props.treeData !== treeData) {
      setTreeData(props.treeData);
      // setCheckedArray(checkedArray);
    }
  }, [props.treeData, treeData]);
  useEffect(() => {
    if (props.checkedArray !== checkedArray) {
      setCheckedArray(props.checkedArray);
      // setCheckedArray(checkedArray);
    }
  }, [props.checkedArray, checkedArray]);


  const getData = (item) => {
    const { Key } = props;
    if (Key === 'Asset') {
      if (item && item.Type === 'Site') {
        message.error('Cant select site');
      } else if (item.Type !== 'Device') {
        props.handleDropdownChange(item);
      } else {
        message.error('Please select valid input');
      }
    } else if (Key === 'Rule' || Key === 'Replicate') {
      if (item && item.Type === 'Site') {
        message.error('Cant select site');
      } else if (item.Type !== 'Device') {
        message.error('Please select Device');
      } else if (item.Type === 'Device') {
        props.handleDropdownChange(item.Code);
        getParent(item.Name, item.ParentId, treeData);
      }
    }
  };
  const getParent = (Name, ParentId, treeData) => {
    let firstLevelParent = {};
    let children = [];
    let secondLevelParent = [];
    for (let i = 0; i < treeData.length; i++) {
      const node = treeData[i];
      if (node.children) {
        if (node.children.some((item) => item.Id === ParentId)) {
          firstLevelParent = node;
          children = node.children;
          if (children) {
            for (let i = 0; i < children.length; i++) {
              const childNode = children[i];
              if (childNode.children && childNode.children.length > 0) {
                if (childNode.Id === ParentId) {
                  secondLevelParent = childNode;
                }
              }
            }
          }
          if (props.handleParentNode) {
            props.handleParentNode(firstLevelParent, secondLevelParent);
          }
        } else if (getParent(Name, ParentId, node.children)) {
          getParent(Name, ParentId, node.children);
        }
      }
    }
    return firstLevelParent;
  };

  const setTranslation = (keyword) => {
    let { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const renderTreeNodes = (data) => {
    // let { Key } = props;
    return (
      data &&
      data.map((item) => {
        if (item.children && item.children.length > 0) {
          return (
            <TreeNode
              title={
                <div onClick={() => getData(item)}>
                  {` ${item.DisplayCode ? `${setTranslation(item.DisplayCode)} ` : ''} ${item.Name ? `(${setTranslation(item.Name)})` : ''
                    }`}
                </div>
              }
              key={item.Id}
              dataRef={item}
            >
              {renderTreeNodes(item.children)}
            </TreeNode>
          );
        }

        return (
          <TreeNode
            key={item.Id}
            title={
              <div onClick={() => getData(item)}>
                {` ${item.DisplayCode ? `${setTranslation(item.DisplayCode)} ` : ''} ${item.Name ? `(${setTranslation(item.Name)})` : ''
                  }`}
              </div>
            }
            dataRef={item}
          />
        );
        // }
      })
    );
  };

  return (
    <div
      style={{
        width: '100%',
        flex: '35%',
        overflowY: 'auto',
        height: window.innerHeight - 250
      }}
    >
      <Tree
        className={props && props.checkedArray !== null ? 'hierarchyTreeSelected' : 'hierarchyTreeNotSelected'}
        showLine defaultExpandAll={true} switcherIcon={<DownOutlined />}>
        {renderTreeNodes(treeData)}
      </Tree>
    </div>
  );
};
export default HierarchyModal;
